import I18n from "i18n-js";
import React from "react";

export default class UserPointsBox extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="user-points-box-wrapper">
        <div className="user-points-box">
          <div className="legend">{I18n.t("current_status")}</div>
          <div className="points">
            <div className="user-points">{this.props.user_total_points}</div>
            <div className="total-points">
              PTS /{" "}
              {this.props.user_current_points_level.number_of_points_range_end}
            </div>
            {this.props.points_reset_date ? (
              <div
                style={{
                  fontSize: "10px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  fontWeight: "bold",
                  color: "#777",
                }}
              >
                {I18n.t("since")} {this.props.points_reset_date}
              </div>
            ) : null}
          </div>
          <div className="level">
            <span className="level-label">LEVEL</span>
            <span className="level-number">
              {this.props.user_current_points_level_name}
            </span>
            <span className="level-image">
              <img src={this.props.image_src} />
            </span>
          </div>
          {this.renderProgressBar()}
          {this.renderPointsToNextLevel()}
        </div>
        <div className="view-learning-history">
          <a href={this.props.learn_more_path}>
            {this.props.points_and_history_link_type == "history"
              ? "View Learning History"
              : "Learn about Ranks and Points"}
          </a>
        </div>
      </div>
    );
  }

  renderProgressBar() {
    return (
      <div className="progress-bar-chart" style={{ marginBottom: 0 }}>
        <div
          className="progress-amount"
          style={{ width: this.progressPercentage() + "%" }}
        ></div>
      </div>
    );
  }

  renderPointsToNextLevel() {
    if (this.hasNextLevel()) {
      return (
        <div className="point-to-next-level">
          <span className="next-level-points">
            {this.props.next_level_points - this.props.user_total_points}
          </span>
          <span className="text">MORE POINTS TO</span>
          <span className="next-level-label">
            LEVEL {this.props.next_level_name}
          </span>
        </div>
      );
    } else {
      return (
        <div className="point-to-next-level">
          <span className="next-level-points">Congratulations!</span>
          <span className="text" style={{ textTransform: "none" }}>
            You've reached our highest level! Keep reading new articles and
            passing courses to boost your knowledge and stay at the top of your
            game.
          </span>
        </div>
      );
    }
  }

  /**
   * Helper functions
   */

  hasNextLevel() {
    return (
      !isNaN(this.props.next_level_points) &&
      this.props.next_level_points - this.props.user_total_points > 0
    );
  }

  progressPercentage() {
    if (this.hasNextLevel()) {
      var percentage = Math.round(
        (this.props.user_total_points / this.props.next_level_points) * 100
      );

      if (percentage > 100) {
        return 100;
      } else if (percentage < 0) {
        return 0;
      } else {
        return percentage;
      }
    } else {
      return 100;
    }
  }
}
